import Vue from 'vue'
Vue.directive('visible', function(el, binding) {
	el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});


// WEBPACK FOOTER //
// ./src/directives/visible.js